import React from 'react'
import PropTypes from 'prop-types'
import {API_BASE_URL} from '../../utils/apiConfig'
import {Card, CardHeader, CardTitle, CardBody} from 'reactstrap'

const FileRow = ({file, onDestroySelect}) => {
  return (
    <li>
      <label>
        {onDestroySelect && <input id="attachment-checkbox" type="checkbox" onClick={() => onDestroySelect(file.id)}/>}
        <span><a href={API_BASE_URL + file.url} target='blank'>{` ${file.data_file_name}`}</a></span>
      </label>
    </li>
  )
}

FileRow.propTypes = {
  file: PropTypes.object.isRequired,
  onDestroySelect: PropTypes.func
}

const FilesList = ({files, onDestroySelect = null}) => {
  if (!files) return <div/>
  
  return (
    <Card>
      <CardHeader>
        <CardTitle><b>Files:</b></CardTitle>
      </CardHeader>
      <CardBody>
        {files.length === 0 ?
          <div className="text-center"><p className="empty-data">No files attached yet</p></div> :
          <ol className="attachment-class attachment-list">
            {files.map(file => <FileRow key={file.id} file={file} onDestroySelect={onDestroySelect}/>)
            }
          </ol>
        }
      </CardBody>
    </Card>
  )
}

FilesList.propTypes = {
  files: PropTypes.array.isRequired,
  onDestroySelect: PropTypes.func
}

FilesList.defaultProps = {
  files: []
}

export default FilesList



// WEBPACK FOOTER //
// ./src/components/Support/FilesList.js